module.exports = __webpack_public_path__ + "static/Toni&Andi-3-blub-a96560c3413e6b38fb737f6d3add4783.jpg";